import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isDateStartOfDay } from 'src/shared/date-helper';

@Pipe({
  name: 'taskDueDateTime',
  standalone: true,
})
export class TaskDueDateTimePipe implements PipeTransform {
  transform(date: Date | string | null, enableTime: boolean): string {
    if (!date) {
      return '';
    }
    if (enableTime && !isDateStartOfDay(date)) {
      return new DatePipe('en-US').transform(date, 'MMM d, y \'at\' h:mm a');
    }
    return new DatePipe('en-US').transform(date, 'MMM d, y');
  }
}
